// extracted by mini-css-extract-plugin
module.exports = {"no-resize_text-area":"textAreaInput_no-resize_text-area__pVLT-"};